'use client';

import React, { ReactNode, useState } from 'react';
import DashboardSidebar from './DashboardSidebar';
import PromoBanner from '@/features/dashboard/components/PromoBanner';
import { useRegionPricing } from '@/features/payment/hooks/useRegionPricing';

interface DashboardLayoutProps {
    children: ReactNode;
    className?: string;
}

const BANNER_HEIGHT = 48; // Fixed banner height

const DashboardLayout = ({ children, className = '' }: DashboardLayoutProps) => {
    const { isIndia } = useRegionPricing();
    const [bannerVisible, setBannerVisible] = useState(() => {
        if (typeof window !== 'undefined') {
            return !localStorage.getItem('hide_promo_flat500');
        }
        return true;
    });

    const showBanner = bannerVisible && isIndia;
    const bannerHeight = showBanner ? BANNER_HEIGHT : 0;

    const handleCloseBanner = () => {
        setBannerVisible(false);
        localStorage.setItem('hide_promo_flat500', 'true');
    };

    return (
        <div
            className="min-h-screen bg-gray-50/50"
            style={{
                '--banner-height': `${bannerHeight}px`
            } as React.CSSProperties}
        >
            <PromoBanner
                isVisible={showBanner}
                onClose={handleCloseBanner}
            />

            <DashboardSidebar />

            {/* Main Content Area */}
            <main
                className={`
                    md:ml-[280px]
                    min-h-screen
                    pt-[calc(3.5rem+var(--banner-height))] md:pt-[var(--banner-height)]
                    transition-all duration-300
                    ${className}
                `}
            >
                {children}
            </main>
        </div>
    );
};

export default DashboardLayout;
